import ApiService from "./base";
import { config } from "@/utils/config";
export default class PasswordResetService extends ApiService {
    constructor(){
        super({
            baseURL: config.apiUrl,
            withCredentials: false
        });
    }
    /**
   * Initiates password reset process by sending a confirmation code to the user's email
   * @param forgotPasswordData - Object containing the user's email
   * @returns Promise with success message and email confirmation
   */ async forgotPassword(forgotPasswordData) {
        return this.post({
            url: '/auth/forgot-password',
            data: forgotPasswordData
        });
    }
    /**
   * Confirms password reset with confirmation code and sets new password
   * @param confirmData - Object containing email, confirmation code, and new password
   * @returns Promise with success confirmation
   */ async confirmForgotPassword(confirmData) {
        return this.post({
            url: '/auth/confirm-forgot-password',
            data: {
                email: confirmData.email,
                confirmationCode: confirmData.confirmationCode,
                password: confirmData.newPassword
            }
        });
    }
    /**
   * Resends the password reset confirmation code to the user's email
   * @param resendData - Object containing the user's email
   * @returns Promise with success message
   */ async resendConfirmationCode(resendData) {
        return this.post({
            url: '/auth/forgot-password',
            data: resendData
        });
    }
}
